import { render, staticRenderFns } from "./viewSalesCataloge.vue?vue&type=template&id=5fc30a54&scoped=true"
import script from "./viewSalesCataloge.vue?vue&type=script&lang=js"
export * from "./viewSalesCataloge.vue?vue&type=script&lang=js"
import style0 from "./viewSalesCataloge.vue?vue&type=style&index=0&id=5fc30a54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc30a54",
  null
  
)

export default component.exports